import { AxiosError, AxiosResponse } from 'axios'
import { useToast } from '@chakra-ui/react'
import { useMutation, useQueryClient } from 'react-query'
import { useTranslation } from 'react-i18next'

import { fetchAPI } from '@/lib/api'
import { useErrorHandler } from '@/lib/hooks'

import { TOAST_CONFIG } from '@/lib/constants'
import { CURRENT_USER } from '@/features/users/constants'

import { ChangeEmailFormInput } from '../types'

type Payload = {
  data: ChangeEmailFormInput
}

export const useUpdateEmail = () => {
  const toast = useToast()
  const handleError = useErrorHandler()
  const queryClient = useQueryClient()

  const { t: tSettings } = useTranslation('settings')

  return useMutation<AxiosResponse, AxiosError, Payload>(
    async ({ data }) => {
      return await fetchAPI({
        path: '/settings/email',
        method: 'put',
        data,
      })
    },
    {
      onSuccess() {
        queryClient.invalidateQueries(CURRENT_USER)

        toast({
          ...TOAST_CONFIG,
          description: tSettings('changeEmailForm.toast.success'),
        })
      },
      onError(error) {
        handleError(error)
      },
    },
  )
}
